import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3575 2.8497C13.8278 2.31041 14.5082 2 15.223 2C16.5901 2 17.7 3.10994 17.7 4.47697C17.7 5.19185 17.3896 5.87537 16.8503 6.34568L10.3537 12.002L10.0308 11.679L8.02414 9.67235L7.69805 9.34627L13.3575 2.8497ZM6.98631 10.0549L7.3124 10.381L9.31906 12.3876L9.64514 12.7137L9.04314 15.3286C8.92086 15.8648 8.51326 16.2912 7.98338 16.4386L2.41175 18L5.40293 15.0088C5.48445 15.0308 5.57224 15.0433 5.66317 15.0433C6.21814 15.0433 6.6665 14.5949 6.6665 14.04C6.6665 13.485 6.21814 13.0366 5.66317 13.0366C5.1082 13.0366 4.65984 13.485 4.65984 14.04C4.65984 14.1309 4.67238 14.2156 4.69433 14.3002L1.70001 17.2883L3.26145 11.7198C3.40881 11.1899 3.83523 10.7823 4.37138 10.66L6.98631 10.058V10.0549Z",
		fill: "#0D2976"
	})
});
export default SvgPen;
